import { ChangeDetectorRef, Directive, OnDestroy, OnInit } from '@angular/core';
import { Wishlist } from '@df/session/api/wishlist/wishlist';
import { Subscription } from 'rxjs';

@Directive()
export abstract class WishlistQtyComponentDef implements OnInit, OnDestroy {
    private wishlistSubscription?: Subscription;

    constructor(
        protected _ref: ChangeDetectorRef,
        public wishlist: Wishlist
    ) {
        this._ref.detach();
    }

    ngOnInit() {
        this.wishlistSubscription = this.wishlist.subscribe(() => this._ref.detectChanges());
        this._ref.detectChanges();
    }

    ngOnDestroy() {
        this.wishlistSubscription?.unsubscribe();
    }
}
